var sdUtils = {
  customFixedNavbar: function() {
      //Make header fixed on scroll    
      function setStickyAttribute() {
        $('.header-fixed--fixed_v2').removeClass('sticky');
        $('.mobile_nav-fixed--fixed_v2').removeClass('sticky');
        document.body.style.paddingTop = "0"
        
        if ($(window).width() > 798 && window.pageYOffset > 1) {
            $('.header-fixed--fixed_v2').addClass('sticky');
          } else if ($(window).width() < 799) {
            $('.mobile_nav-fixed--fixed_v2').addClass('sticky');
            document.body.style.paddingTop = "73px"
          //made sticky class permanent on mobile to combat jumpy behavior
          }
        }
        window.onscroll = function() {setStickyAttribute()};
  },
  
  handleize: function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },
  cartInit: function () {
    if ($('body').hasClass('cart')) {
      // Trigger cart pop up if message present
      $.fancybox.open($('#cartpage-popup'), {
        baseClass: 'newsletter__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: true,
          buttons: [
            "close"
          ]
        }
      });

    }
  },

  checkGiftCardOnlyCart: function () {
    var cartItems = JSON.parse(document.getElementById('cart-items').textContent);
    var giftCardsInCart = cartItems.filter(function(cartItem) {
      return cartItem.handle.includes('gift-card')
    });

    return giftCardsInCart.length == cartItems.length;
  }
}

if($(window).width() < 799) document.body.style.paddingTop = "73px"

//wishlist logic
const wishlist = {
  key: 'wishlist',

  emit() {
    window.dispatchEvent(new CustomEvent('wishlist:updated'))
  },

  get() {
    try {
      return JSON.parse(localStorage.getItem(this.key)) || []
    } catch {
      return []
    }
  },

  set(list) {
    localStorage.setItem(this.key, JSON.stringify(list))
  },

  add(item) {
    const normalized = {
      handle: item.handle,
      variantId: Number(item.variantId),
      addedAt: Date.now()
    }

    const list = this.get()

    const exists = list.some(
      x =>
        x.handle === normalized.handle &&
        Number(x.variantId) === normalized.variantId
    )

    if (!exists) {
      list.push(normalized)
      this.set(list)
      this.emit()
    }
  },

  remove(item) {
    const list = this.get().filter(
      x =>
        !(
          x.handle === item.handle &&
          Number(x.variantId) === Number(item.variantId)
        )
    )

    this.set(list)
    this.emit()
  },

  has(item) {
    return this.get().some(
      x =>
        x.handle === item.handle &&
        Number(x.variantId) === Number(item.variantId)
    )
  }
}